export default __webpack_public_path__ + "locales/uk-UA/FormGallery.json?hash=5b3db9b9fbaa898a93d3af8024eac0ea";